export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7752.6344cf58.jpg";